// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export const PLACEHOLDER_HIGHLIGHT_CLASS = 'placeholder-highlight';
export const SMART_RESPONSE_HIGHLIGHT_CLASS = 'smart-response-highlight';
